import { render, staticRenderFns } from "./RedesSociales.vue?vue&type=template&id=679c95fa"
import script from "./RedesSociales.vue?vue&type=script&lang=js"
export * from "./RedesSociales.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/github/workspace/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('679c95fa')) {
      api.createRecord('679c95fa', component.options)
    } else {
      api.reload('679c95fa', component.options)
    }
    module.hot.accept("./RedesSociales.vue?vue&type=template&id=679c95fa", function () {
      api.rerender('679c95fa', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/clients/comparecientes/RedesSociales.vue"
export default component.exports